import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "text-2xl tracking-normal capitalize md:text-3xl" }
const _hoisted_3 = { class: "text-lg capitalize md:text-xl" }
const _hoisted_4 = { class: "flex justify-end py-2" }

import RouterButton from "./RouterButton.vue";
import { PropType } from "vue";
import { Template } from "@/types";


export default /*#__PURE__*/_defineComponent({
  __name: 'TemplateBlock',
  props: {
  template: {
    type: Object as PropType<Template>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(__props.template.name), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(__props.template.level), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(RouterButton, {
        to: { name: 'Course_Template', params: { id: __props.template.id } },
        type: "primary",
        loading: false,
        disabled: false
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('view-template')), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ]))
}
}

})